import React, { useState, useEffect, useRef } from "react";
import {
	Table,
	Button,
	Modal,
	Form,
	Input,
	Row,
	Col,
	Space,
	Card,
	notification,
	message,
} from "antd";
import {
	SearchOutlined,
	TeamOutlined,
	EditOutlined,
	DeleteOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
// import { useSelector } from "react-redux";
import departmentService from "../../services/department";
import { Excel } from "antd-table-saveas-excel";

const Departments = () => {
	const [searchQuery, setSearchQuery] = useState("");

	const [form] = Form.useForm();

	const [isModalVisible, setIsModalVisible] = useState(false);
	const [editing, setEditing] = useState(null);
	const [searchText, setSearchText] = useState("");
	const [searchedColumn, setSearchedColumn] = useState("");

	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);

	const [currentPage, setCurrentPage] = useState(1);
	const [totalDataCount, setTotalDataCount] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(15);

	// const { currentUser } = useSelector((state) => state.user);

	const searchInput = useRef(null);

	const handleSearch = (selectedKeys, confirm, dataIndex) => {
		confirm();
		setSearchText(selectedKeys[0]);
		setSearchedColumn(dataIndex);
	};

	const handleClick = () => {
		const excelColumns = columns
			.filter((column) => column.key !== "Actions")
			.map((column) => {
			const { render, ...columnWithoutRender } = column;
			return columnWithoutRender;
			});

		const excel = new Excel();
		excel
			.addSheet("data")
			.addColumns(excelColumns)
			.addDataSource(data, {
			str2Percent: true,
			})
			.saveAs("department.xlsx");
	};

	const handleDelete = (record) => {
		Modal.confirm({
			title: "Confirm Deletion",
			content: `Are you sure you want to delete the department: ${record.name}?`,
			onOk: async () => {
				setLoading(true);
				try {
					const response = await departmentService.deleteDepartment(record.id);
					if (response.success) {
						notification.success({
							message: "Department Deleted",
							description: response.message,
						});
						getDepartments(currentPage);
					}
				} catch (error) {
					notification.error({
						message: "Error",
						description: error.response.data.message,
					});
				} finally {
					setLoading(false);
				}
			},
		});
	};

	const handleReset = (clearFilters) => {
		clearFilters();
		setSearchText("");
	};

	const handleInputChange = (event) => {
		const newSearchQuery = event.target.value;
		setSearchQuery(newSearchQuery);
		if (newSearchQuery.length > 1 || newSearchQuery === "") {
			getDepartments(1, newSearchQuery);
		}
	};

	const getDepartments = async (page = 1, searchQuery = "") => {
		setLoading(true);

		await departmentService
			.getDepartmentUP(page, itemsPerPage, searchQuery)
			.then((response) => {
				console.log("this is ress");
				console.log(response);
				console.log("this is ress");
				setData(response.data);
				setCurrentPage(page);
				setTotalDataCount(response.total);
				setItemsPerPage(response.per_page);
				setLoading(false);
			});
	};

	useEffect(() => {
		getDepartments();
	}, []);

	const getColumnSearchProps = (dataIndex) => ({
		filterDropdown: ({
			setSelectedKeys,
			selectedKeys,
			confirm,
			clearFilters,
		}) => (
			<div style={{ padding: 8 }}>
				<Input
					ref={searchInput}
					placeholder={`Search ${dataIndex}`}
					value={selectedKeys[0]}
					onChange={(e) =>
						setSelectedKeys(e.target.value ? [e.target.value] : [])
					}
					allowClear
					onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
					style={{ width: 188, marginBottom: 8, display: "block" }}
				/>
				<Space>
					<Button
						type='primary'
						onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
						icon={<SearchOutlined />}
						size='small'
						style={{ width: 90 }}
					>
						Search
					</Button>
					<Button
						onClick={() => handleReset(clearFilters)}
						size='small'
						style={{ width: 90 }}
					>
						Reset
					</Button>
				</Space>
			</div>
		),
		filterIcon: (filtered) => (
			<SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
		),
		onFilter: (value, record) =>
			record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
		onFilterDropdownOpenChange: (visible) => {
			if (visible) {
				setTimeout(() => searchInput.current.select(), 100);
			}
		},
		render: (text) =>
			searchedColumn === dataIndex ? (
				<Highlighter
					highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
					searchWords={[searchText]}
					autoEscape
					textToHighlight={text}
				/>
			) : (
				text
			),
	});

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		setEditing(null);
		form.resetFields();
	};

	const handleEdit = (record) => {
		console.log("handleEdit");
		console.log(record);
		setEditing(record);
		form.setFieldsValue(record);
		setIsModalVisible(true);
	};

	const onFinish = async (values) => {
		setLoading(true);

		try {
			if (editing) {
				const response = await departmentService.updateDepartment(
					editing.id,
					values
				);

				if (response.success) {
					setIsModalVisible(false);
					setEditing(null);

					form.resetFields();

					notification.success({
						message: "Department Updated",
						description: response.message,
					});

					getDepartments(currentPage);
				}
			} else {
				const response = await departmentService.postDepartment(values);

				if (response.success) {
					setIsModalVisible(false);
					setEditing(null);
					form.resetFields();

					notification.success({
						message: "Department Added",
						description: response.message,
					});

					getDepartments(currentPage);
				}
			}
		} catch (error) {
			notification.error({
				message: "Error",
				description: error.response.data.message,
			});
		} finally {
			setLoading(false);
		}
	};

	const columns = [
		{
			title: "Department Name",
			dataIndex: "name",
			key: "name",
			sorter: (a, b) => a.name.localeCompare(b.name),
			//...getColumnSearchProps('name'),
		},
		{
			title: "Actions",
			key: "actions",
			fixed: "right",
			width: 80,
			render: (text, record) => (
				<Space>
					<div onClick={() => handleEdit(record)} style={{ cursor: "pointer" }}>
						<EditOutlined />
					</div>

					<div
						onClick={() => handleDelete(record)}
						style={{ cursor: "pointer" }}
					>
						<DeleteOutlined />
					</div>
				</Space>
			),
		},
	];

	return (
		<DefaultLayout>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Header
						icon={<TeamOutlined />}
						title='Departments'
						right={

							<>
								<Button onClick={handleClick} className='mr-10'>
									Export
								</Button>
								<Button className='btn-blue' type='primary' onClick={showModal}>
									Add Department
								</Button>
							</>
						}
					/>
				</Col>
			</Row>

			<Card>
				<Input
					size='large'
					placeholder='Search'
					value={searchQuery}
					onChange={handleInputChange}
				/>
			</Card>

			<Card>
				<Table
					style={{ minHeight: "100vh" }}
					columns={columns}
					dataSource={data.map((item) => ({ ...item, key: item.id }))}
					pagination={{
						total: totalDataCount,
						current: currentPage,
						pageSize: itemsPerPage,
						showSizeChanger: false,
						onChange: (page, pageSize) => getDepartments(page),
					}}
					loading={loading}
				/>
			</Card>

			<Modal
				title={editing ? "Edit Department" : "Add Department"}
				open={isModalVisible}
				onCancel={handleCancel}
				footer={null}
				width={650}
			>
				<Form
					form={form}
					onFinish={onFinish}
					layout='vertical'
					className='mt-20'
				>
					<Form.Item
						name='name'
						label='Department'
						rules={[{ required: true, message: "Please enter the department" }]}
					>
						<Input size='large' placeholder='Type Department Name' />
					</Form.Item>

					<Form.Item>
						<Button type='primary' htmlType='submit' loading={loading}>
							{" "}
							{editing ? "Save Changes" : "Add Department"}
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</DefaultLayout>
	);
};

export default Departments;
